<template>
  <div id="app">

    <!--Navigation-->
    <router-view name="navigation" />

    <main v-if="viewReady">
      <router-view />
    </main>

    <confirm-modal />
    <on-hold-modal />
    <close-lead-modal />
    <give-lead-back-modal />
    <message-lead-modal />
    <case-updated-modal/>

  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import OnHoldModal from '@/components/Modals/OnHoldModal.vue';
import CloseLeadModal from '@/components/Modals/CloseLeadModal.vue';
import GiveLeadBackModal from '@/components/Modals/GiveLeadBackModal.vue';
import MessageLeadModal from '@/components/Modals/MessageLeadModal.vue';
import CaseUpdatedModal from '@/components/Modals/CaseUpdatedModal.vue';

export default {
  components: {
    ConfirmModal,
    CloseLeadModal,
    GiveLeadBackModal,
    OnHoldModal,
    MessageLeadModal,
    CaseUpdatedModal,
  },
  data() {
    return {
      agentKey: '',
      userKey: '',
    };
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
  },
  computed: {
    ...mapState({
      leadsList: state => state.leadsListStore.leadsList,
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      agentsForPrincipal: state => state.principalStore.agentsForPrincipal,
      allLeadsListForPrincipal: state => state.principalStore.allLeadsListForPrincipal,

      // For Premier Lead List
      attentionLams: state => state.premierLeadsListStore.attentionLeadsList,
      openLams: state => state.premierLeadsListStore.openLeadsList,
      onHoldLams: state => state.premierLeadsListStore.onHoldLeadsList,
      wonLams: state => state.premierLeadsListStore.wonLeadsList,
      lostLams: state => state.premierLeadsListStore.lostLeadsList,
      closedLams: state => state.premierLeadsListStore.closedLeadsList,
    }),
    ...mapGetters('userStore', [
      'isPremier',
      'isPrincipal',
      'isAgent',
    ]),
    viewReady() {
      if (this.$route.params.ak || this.$route.params.uk) {
        if (this.$route.params.ak && this.$route.params.uk) {
          return !!this.user.key && this.agent.key;
        }

        if (!this.$route.params.ak && this.$route.params.uk) {
          return !!this.user.key;
        }
      }

      return true;
    },
  },
  mounted() {
    this.fetchData();
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case 'leadAgentMappingStore/setLeadAgentMapping':
          this.refreshLeadsList(mutation.payload);
          break;
        default:
          break;
      }
    });
  },
  methods: {
    ...mapActions('principalStore', [
      'loadAgentsForPrincipal',
    ]),
    fetchData() {
      if (this.$route.params.uk) { // Do we have a userKey?
        this.fetchUserData(this.$route.params.uk)
          .then(() => {
            // Only load agent data when user is an agent
            if (this.isAgent) {
              this.fetchAgentData(this.user.agentkey).catch(err => console.error(err));
            }
          }).catch(err => console.error(err));
      } else if (this.$route.params.ak) { // Do we have an agentKey?
        this.fetchAgentData(this.$route.params.ak).catch(err => console.error(err));
      }
    },
    fetchUserData(userKey) {
      if (userKey !== this.userKey) {
        console.log(`%cLoad user: ${userKey}`, 'background: #222; color: #bada55');
        this.userKey = userKey;
        return this.$store.dispatch('userStore/loadUser', this.userKey).then(() => {
          if (this.isPrincipal) {
            return Promise.resolve(this.loadAgentsForPrincipal(this.$route.params.uk));
          }

          return Promise.resolve();
        }).catch(err => console.error(err));
      }
      return Promise.resolve();
    },
    fetchAgentData(agentKey) {
      if (agentKey !== this.agentKey) {
        this.agentKey = agentKey;
        if (this.$route.params.ak && (this.$route.params.ak !== this.agentKey) && !this.isAgentForPrincipal(this.$route.params.ak)) {
          this.redirect();
        }

        console.log(`%cLoad Agent: ${this.agentKey}`, 'background: #222; color: #bada55');
        return Promise.all([
          this.$store.dispatch('experimentStore/loadAgentExperiments', this.agentKey),
          this.$store.dispatch('agentStore/loadAgent', this.agentKey),
        ]).then(() => {
          if (!this.user || (this.agent && this.agent.userkey !== this.user.key)) {
            return this.fetchUserData(this.agent.userkey).catch(err => console.error(err));
          }
          return Promise.resolve();
        }).catch(err => console.error(err));
      }
      return Promise.resolve();
    },
    isAgentForPrincipal(agentKey) {
      for (let i = 0; i < this.agentsForPrincipal.length; i += 1) {
        if (this.agentsForPrincipal[i].Key === agentKey) {
          return true;
        }
      }
      return false;
    },
    refreshLeadsList(lam = null) {
      const payload = {
        leadsList: this.leadsList,
        lam,
        agentKey: this.agentKey,
        userKey: this.agent.userkey,
        attentionLams: this.attentionLams,
        openLams: this.openLams,
        onHoldLams: this.onHoldLams,
        wonLams: this.wonLams,
        lostLams: this.lostLams,
        closedLams: this.closedLams,
      };

      this.$store.dispatch('leadsListStore/refreshLeadsList', payload);
      if (this.isPremier) {
        console.log('%cisPremier', 'background: #222; color: #bada55');
        this.$store.dispatch('premierLeadsListStore/refreshLeadsList', payload);
      }
      if (this.isPrincipal && lam) {
        console.log('%cisPrincipal', 'background: #222; color: #bada55');
        this.$store.dispatch(
          'principalStore/refreshLeadAgentMappingInList',
          { leadsList: this.allLeadsListForPrincipal, lam },
        );
      }
    },
    redirect() {
      this.$route.params.ak = this.agentKey;

      if (this.isPrincipal && (this.$route.name === 'lead')) {
        this.$router.push({
          name: 'leads',
          params: {
            ak: this.agentKey, // agentKey
            uk: this.$route.params.uk, // userKey
            lk: this.$route.params.lk, // leadKey
            ck: this.$route.params.ck, // Prospecting - contactKey
            pk: this.$route.params.pk, // Prospecting - prospectKey
          },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: this.$route.name,
          params: {
            ak: this.agentKey, // agentKey
            uk: this.$route.params.uk, // userKey
            lk: this.$route.params.lk, // leadKey
            ck: this.$route.params.ck, // Prospecting - contactKey
            pk: this.$route.params.pk, // Prospecting - prospectKey
          },
          hash: this.$route.hash,
        });
      }


      this.refreshLeadsList();
    },
  },
};

</script>

<style lang="scss">

@import "assets/styles/app";

*, html, body {
  font-family: "Lato","Helvetica Neue", sans-serif !important;
}

body {
  background-color: #F7F7F5;
  min-height: 100%;
}

main {
  .page-header {
    @apply ut-mb-12;
    background-color: #F0EFED;
    border-bottom: 1px solid #D6D5D2;
  }

  @screen lg {
    margin-left: 280px;
  }
}

</style>
